// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3jYBr","list":"BalanceDue_list__1jIoL","listRow":"BalanceDue_listRow__18h2Y","total":"BalanceDue_total__3QynT"};